import { render, staticRenderFns } from "./CheckboxType.vue?vue&type=template&id=e696955a&scoped=true&"
import script from "./CheckboxType.vue?vue&type=script&lang=js&"
export * from "./CheckboxType.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxType.vue?vue&type=style&index=0&id=e696955a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e696955a",
  null
  
)

export default component.exports